<template>
  <div id="floatCountDown">
    <div :class="[backgroundClass, 'flex items-center']">
      <div class="container flex flex-wrap justify-between items-center py-8 mb-py-20">
        <div class="relative mb-mb-16">
          <span class="dt-dib">
            <span class="text-md-sb">{{ !expired ? 'This offer expires in ' : `This offer is expired. ` }}</span>
            <span class="mb-db" v-if="!expired"> <CountdownTimer class="text-md-sb" />. </span>
          </span>
          <span v-if="!expired" class="text-md-sb mb-db">Confirm now to secure the offer. Minor modifications can continue afterwards. </span>
        </div>
        <TripButton size="small" buttonType="primary" buttonIdPrefix="button-bookable-trip-plan-top" @handleBook="emitBook" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, inject } from "vue";
import TripButton from '~/components/pages/TripPlanDetail/sections/SectionTripPriceBox/TripButton.vue'
import CountdownTimer from '~/components/sections/SectionCountdown/CountdownTimer.vue'

const emit = defineEmits(['handleBook', 'confirmDate'])

const expired = inject('isExpired', false)

const backgroundClass = computed(() => {
  if (!expired?.value) {
    return 'bg-yellow-500 white'
  }
  return 'bg-gray-700 white'
})

const emitBook = (data) => {
  emit('handleBook', data)
}
</script>
<style lang="scss" scoped>
.expired-text-open img {
  transform: rotate(180deg);
}
</style>
